const API_BASE = "https://tansmartx-api-446662168422.asia-southeast1.run.app";

export async function fetchDashboard(projectId, granularity = "daily") {
  const res = await fetch(
    `${API_BASE}/api/gcp/dashboard?projectId=${encodeURIComponent(projectId)}&granularity=${encodeURIComponent(granularity)}`
  );

  if (!res.ok) {
    throw new Error(`Failed to load dashboard: ${res.status}`);
  }

  return res.json();
}